import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-muted px-5 py-20 sm:py-28" data-id="element-18" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="avcvgfktva6b">
        <div className="mx-auto max-w-2xl text-center" data-id="element-20" data-mp="aujzm9neq52y">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-soft px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.18em] text-primary-hover" data-id="element-21" data-mp="ftwi6i78wpzq">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="1wrh6wme2hbc" />
            Seulement aujourd&apos;hui
          </span>
          <h2 className="mt-5 font-display text-[1.9rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-23" data-mp="3o1v8io5p48td">
            5 Bonus <span className="italic text-emphasis" data-id="element-24" data-mp="3t183jw6q0m71">Stratégiques</span>{' '}
            offerts
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-foreground/60" data-id="element-25" data-mp="1mb1l5epgunat">
            Cinq kits supplémentaires pensés pour la classe de musique, inclus
            dans votre commande d&apos;aujourd&apos;hui sans coût additionnel.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="3dea994tuhm9s">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex h-full flex-col overflow-hidden rounded-3xl bg-surface shadow-card-lg" data-id="element-27" data-mp="3r68gtb7wra3u" data-mpi={index}>
              <div className="relative bg-surface px-6 pb-6 pt-10" data-id="element-28" data-mp="2zesjam4tc2yu">
                <span className="absolute left-5 top-5 flex h-9 w-9 items-center justify-center rounded-full bg-inverse font-display text-sm font-bold text-surface" data-id="element-29" data-mp="2ugh9gbeipsgm">
                  {index + 1}
                </span>
                <span className="absolute right-5 top-5 rounded-full bg-primary px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-primary-foreground" data-id="element-30" data-mp="33gnviloa80re">
                  Bonus
                </span>
                <img src={bonus.cover} alt={`Couverture du bonus ${bonus.title}`} className="mx-auto h-72 w-auto object-contain mix-blend-multiply sm:h-80" data-id="element-31" data-mp="ipwt54pdm003" />
              </div>

              <div className="flex flex-1 flex-col px-6 pb-7 pt-6" data-id="element-32" data-mp="3hju86yyag7j2">
                <h3 className="font-display text-base font-bold leading-snug text-foreground" data-id="element-33" data-mp="3lk4d08acgrwc">
                  {bonus.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground/60" data-id="element-34" data-mp="2tseyum83gpyb">
                  {bonus.text}
                </p>
                <p className="mt-5 border-t border-foreground/10 pt-4 text-[11px] font-bold uppercase tracking-[0.12em] text-success" data-id="element-35" data-mp="2xv1uyzbssx1b">
                  Inclus gratuitement
                </p>
              </div>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-3xl border-2 border-dashed border-foreground/20 bg-background px-6 py-10 text-center" data-id="element-36" data-mp="37lo7gko7x7fs">
            <span className="font-display text-4xl font-black text-foreground" data-id="element-37" data-mp="2f1y0xcuo4i66">5</span>
            <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.16em] text-foreground/45" data-id="element-38" data-mp="27iyfl1nncgk6">
              bonus inclus
            </p>
            <p className="mt-4 max-w-[15rem] text-xs leading-relaxed text-foreground/60" data-id="element-39" data-mp="22j3tdbetgf5g">
              Les 5 kits sont envoyés avec les volumes, dans le même email,
              immédiatement après l&apos;achat.
            </p>
            <span className="mt-5 rounded-full bg-success px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.12em] text-surface" data-id="element-40" data-mp="1olnmxzwisldp">
              Déjà inclus
            </span>
          </li>
        </ol>
      </div>
    </section>;
}